import React from "react";
import { CogIcon, DownloadIcon } from "@heroicons/react/outline";
import Button from "components/Button";

interface TableActionsProps {
  onCustomize: () => void;
  onDownload?: () => void | Promise<void>;
  downloadText?: string;
  downloadLoadingText?: string;
  downloadDisabled?: boolean;
  downloadLoading?: boolean;
  isMobile: boolean;
  isTablet: boolean;
}

const TableActions: React.FC<TableActionsProps> = ({
  onCustomize,
  onDownload,
  downloadText,
  downloadLoadingText,
  downloadDisabled,
  downloadLoading,
  isMobile,
  isTablet,
}) => {
  const resolvedDownloadText = downloadLoading
    ? downloadLoadingText || "DOWNLOADING..."
    : downloadText || "DOWNLOAD LOGS";

  return (
    <div className="flex items-center gap-1">
      <Button
        icon={{ Icon: CogIcon }}
        text={isMobile || isTablet ? "" : "CUSTOMIZE COLUMNS"}
        className="button button-tertiary whitespace-nowrap px-3 text-sm"
        onClick={onCustomize}
      />
      <Button
        icon={{ Icon: DownloadIcon }}
        text={isMobile || isTablet ? "" : resolvedDownloadText}
        className="button button-tertiary whitespace-nowrap px-3 text-sm"
        onClick={onDownload}
        disabled={downloadDisabled || downloadLoading}
      />
    </div>
  );
};

export default TableActions;
